import { useMediaQuery } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { assetDomain } from "../../../config/config";
import JobCard from "../JobCard/JobCard";
import {
  JobCardSkeletonDesktop,
  JobCardSkeletonMobile,
} from "../JobCardSkeleton/JobCardSkeleton";
import {
  EmptyContainer,
  NextImageStyled,
  TypographyStyled,
  Wrapper,
} from "./styles";

function SingleJobWrapper() {
  const jobs = useSelector((state) => state.jobs.jobs);
  const fetchingAllJobs = useSelector((state) => state.jobs.fetchingAllJobs);
  const mobileView = useMediaQuery("(max-width:768px)");

  const searchKeyword = useSelector(
    (state) => state?.jobs?.jobsParams?.keywordDisplay
  );

  const aboveLg = useMediaQuery("(min-width:1281px)");

  const emptyStateSvg =
    assetDomain + "/images/empty-state/joblist-empty-state.svg";

  return (
    <Wrapper
      container
      justifyContent="center"
      gap="15px"
      flexDirection="column"
      alignItems="center"
    >
      {fetchingAllJobs && !mobileView ? (
        Array.from({ length: 20 }).map((index) => {
          return <JobCardSkeletonDesktop key={index} />;
        })
      ) : fetchingAllJobs && mobileView ? (
        Array.from({ length: 20 }).map((index) => {
          return <JobCardSkeletonMobile key={index} />;
        })
      ) : jobs.length === 0 ? (
        <EmptyContainer
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <NextImageStyled
            src={emptyStateSvg}
            width={300}
            height={300}
            style={{
              objectFit: "contain",
            }}
          />
          <TypographyStyled
            variant={mobileView ? "h5_bold_L" : "h5"}
            textAlign={"center"}
            paddingBottom={"30px"}
          >
            {`No result found for`} <b>{searchKeyword}</b>{" "}
            {searchKeyword === "" && `this filter.`}
          </TypographyStyled>

          <TypographyStyled
            variant={mobileView ? "body1_L" : "h5_bold_L"}
            textAlign={"center"}
          >
            Search Tips
          </TypographyStyled>

          <ul>
            <li>Ensure that the search terms are spelled correctly</li>
            <li>Try different search terms</li>
            <li>Adjust your filters to widen your search</li>
          </ul>
        </EmptyContainer>
      ) : (
        jobs.map((job) => {
          return (
            <JobCard key={job.id} job={job} jobList={true} origin="job_list" />
          );
        })
      )}
    </Wrapper>
  );
}

export default SingleJobWrapper;
